import { stopStreamKO, stopStreamOK } from "@blacknut/javascript-sdk/dist";
import { Dispatch } from "redux";
import { GameAction, GameActionTypes } from "./Game";
import { logError } from "@blacknut/logging/dist";
export const streamStopped = (
  streamId: string,
  message: string,
  error?: string,
  userExit?: boolean,
) => {
  return (dispatch: Dispatch<GameAction>) => {
    return new Promise<void>((resolve) => {
      if (error) {
        stopStreamKO(streamId, error).subscribe({
          next: () => {
            dispatch({
              type: GameActionTypes.STREAM_STOPPED,
            });
            resolve();
          },
          error: (err) => {
            logError("Error on streamStopped", err);
            resolve();
          },
        });
      } else {
        stopStreamOK(streamId, message, userExit).subscribe({
          next: () => {
            dispatch({
              type: GameActionTypes.STREAM_STOPPED,
            });
            resolve();
          },
          error: (err) => {
            logError("Error on streamStopped", err);
            resolve();
          },
        });
      }
    });
  };
};
